var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgScheduledIconTimer = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13.429,
    height: 11.798,
    viewBox: "0 0 13.429 11.798",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_sch_upd_timer",
    "data-name": "Icon sch upd timer",
    d: "M-1150.64-3257.184a5.393,5.393,0,0,1,5.387-5.386,5.393,5.393,0,0,1,5.387,5.386q0,.145-.008.289h-.981c.006-.1.01-.192.01-.289a4.411,4.411,0,0,0-4.407-4.407,4.412,4.412,0,0,0-4.407,4.407,4.414,4.414,0,0,0,3.917,4.381v.984A5.393,5.393,0,0,1-1150.64-3257.184Zm9.565,1.52-.812-1.23h3.246l-.812,1.23-.812,1.405Zm-2.285,1.223-2.2-1.715a.491.491,0,0,1-.188-.386v-3.917a.49.49,0,0,1,.489-.49.491.491,0,0,1,.49.49v3.679l2.007,1.568a.489.489,0,0,1,.084.688.488.488,0,0,1-.387.188A.486.486,0,0,1-1143.36-3254.442Z",
    transform: "translate(1151.14 3263.071)",
    fill: "#3953fb",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1
  })));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgScheduledIconTimer, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/scheduledIconTimer.ca4b63e8.svg";
export { ForwardRef as ReactComponent };